import { Icon, IconName } from "@blueprintjs/core";
import {
    determineFuelType,
    FuelTypeIcon,
    FuelTypeKey
} from "in_queue/icons/fuelType/FuelTypeIcon";
import React from "react";

// Matches Blueprint's $pt-text-color-muted, same as FuelTypeIcon's plain
// variant, so the glyphs read identically to the other plain icons.
const PLAIN_ICON_COLOR = "#5f6b7c";

// Fuel types swapped to Blueprint's built-in glyphs on the bus page —
// wind matches the prospecting `GeneratorTypeIcon`, and the others read
// better than the in-queue SVGs at small sizes.
const BLUEPRINT_GLYPH_OVERRIDES: Partial<Record<FuelTypeKey, IconName>> = {
    wind: "wind",
    gas: "flame",
    hybrid: "resolve"
};

/**
 * Bus-page wrapper around the in-queue `FuelTypeIcon` (plain variant).
 * Some fuel types are special-cased to Blueprint's built-in glyphs (see
 * `BLUEPRINT_GLYPH_OVERRIDES`). Scoped here so the In-Queue app's icons
 * are untouched.
 */
export const BusPageFuelTypeIcon: React.FC<{
    readonly fuelType: string | null | undefined;
    readonly size?: number;
}> = ({ fuelType, size = 16 }) => {
    const glyph = BLUEPRINT_GLYPH_OVERRIDES[determineFuelType(fuelType)];
    if (glyph !== undefined) {
        // Blueprint glyphs fill their bounding box more aggressively
        // than the fuel-type SVGs, so render them ~2px smaller to keep
        // the visual weight consistent.
        return (
            <span
                style={{
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: PLAIN_ICON_COLOR
                }}
            >
                <Icon icon={glyph} size={size - 2} />
            </span>
        );
    }
    return <FuelTypeIcon fuelType={fuelType} size={size} variant="plain" />;
};
